import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { YES, NO } from '../../data/constants';
import { Back, Next, ChatToAFitter } from '../ControlButtons';
import { SizeQuizButton, SizeQuizExampleButton } from '../selects/Buttons';
import { dataLayerGA4SizeQuizStageNumber } from '../../../shared/utils/data-layer';

const Stage4 = ({
  buttonSelected,
  defaultButtonProps,
  defaultNextProps,
  defaultPreviousProps,
  intl: { formatMessage },
  messages,
}) => {
  const STAGE_NUMBER = '4';

  useEffect(() => {
    window.scrollTo(0, 0);
    dataLayerGA4SizeQuizStageNumber(STAGE_NUMBER);
  }, []);

  return (
    <div className="stageContainer">
      <div className="standardQuestionContainer">
        <Back
          {...defaultPreviousProps(1, formatMessage(messages.restartBackSize))}
        />
        <div className="stage stage-4">
          <div className="wrap wrap--left">
            <h4>{formatMessage(messages.stage4para1)}</h4>
            <SizeQuizExampleButton
              className="stage__tooltipBtn"
              message={formatMessage(messages.example)}
            />

            <div className="buttonsContainer">
              {[YES, NO].map((text, idx) => (
                <SizeQuizButton key={idx} {...defaultButtonProps(text, idx)} />
              ))}
            </div>
            <div>
              <Next
                hasChevron
                disabled={!buttonSelected}
                {...defaultNextProps(1, 'Next question')}
              />
            </div>
          </div>
        </div>
      </div>
      <hr className="contentDivider" />
      <div id="fittersAdvice" className="contentContainer">
        <h4 className="contentHeader">
          {formatMessage(messages.adviceFromABraFitterHeader)}
        </h4>
        <picture className="c-picture">
          <source
            srcSet="//images.ctfassets.net/bz0fvtkbk5r1/4n6OpApyaYgLuNDKYfQE1G/0ec0d0861573be987e66ba54541a5fb1/Boob-showing-underband.jpg?q=80&amp;w=868&amp;fm=webp"
            type="image/webp"
          />
          <img
            alt="Why do my boobs come out of the bottom of my bra?"
            src="//images.ctfassets.net/bz0fvtkbk5r1/4n6OpApyaYgLuNDKYfQE1G/0ec0d0861573be987e66ba54541a5fb1/Boob-showing-underband.jpg?q=80&amp;w=868"
            className="c-image"
          />
        </picture>
        <p className="contentSubHeader">
          {formatMessage(messages.stage4para2)}
        </p>
        <ChatToAFitter stage={STAGE_NUMBER} />
      </div>
    </div>
  );
};

export default injectIntl(Stage4);

Stage4.propTypes = {
  Back: PropTypes.func,
  backSize: PropTypes.string,
  SizeQuizButton: PropTypes.func,
  buttonSelected: PropTypes.number,
  cupSize: PropTypes.string,
  defaultButtonProps: PropTypes.func,
  defaultNextProps: PropTypes.func,
  defaultPreviousProps: PropTypes.func,
  SizeQuizExampleButton: PropTypes.func,
  intl: intlShape,
  messages: PropTypes.object,
  Next: PropTypes.func,
  resetSizeAndCaches: PropTypes.func,
  tooltip: PropTypes.object,
};
